import type { AdminActionLog } from "@shared/types";
import { apiClient } from "@/lib/api-client";

export type { AdminActionLog };

export interface AdminActionLogPage {
	logs: AdminActionLog[];
	nextCursor: string | null;
}

/**
 * Filters the backend actually validates.
 *
 * `listAdminActionLogsSchema` accepts exactly these keys and rejects anything
 * else, so the screen offers only filters that can succeed.
 */
export interface AdminActionLogFilters {
	action?: string;
	subjectType?: string;
	actorUserId?: string;
	subjectId?: string;
	subjectUserId?: string;
	limit?: number;
	cursor?: string;
}

export async function listAdminActionLogs(
	filters: AdminActionLogFilters,
): Promise<AdminActionLogPage> {
	// Drop empty values. `action` and `subjectType` carry min(1); the three id
	// filters are .uuid(). Either way an empty string is a 400 rather than
	// "no filter", so an unset filter has to be absent, not blank.
	const params = Object.fromEntries(
		Object.entries(filters).filter(
			([, value]) => value !== undefined && value !== "",
		),
	);
	const response = await apiClient.get("/api/v1/admin/logs", { params });
	return response.data.data as AdminActionLogPage;
}
